export default {
    log_selected: null,
    area_selected: null,
    logBookView: false,
    captureCount: 0,
    evidences: [],
    log_edit:false,
    subject_edit:"",
    date_edit:null,
    descripton_edit:""
  };
  